import {
    FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE, FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE_SUCCESS, FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE_FAILURE,
    FETCH_CONTENT, FETCH_CONTENT_SUCCESS, FETCH_CONTENT_FAILURE,
    REMOVE_CONTENT, REMOVE_CONTENT_SUCCESS, REMOVE_CONTENT_FAILURE,
    SAVE_CONTENT, SAVE_CONTENT_SUCCESS, SAVE_CONTENT_FAILURE,
    CLEAR_CONTENT_TO_PREVIEW, CLEAR_CONTENT_SINGLE, EMPTY_CONTENT, SET_CONTENT_SINGLE, SET_CONTENT_PIECE_TO_PREVIEW, SET_CONTENT_SET_TO_PREVIEW,
    UPDATE_CONTENT, UPDATE_SEARCH_TERM, UPDATE_FILE_TO_UPLOAD
} from './constants';

const emptyContentPiece = {
    name: '',
    description: '',
    type: 'file'
};

const initialState = {
    all: [],
    single: JSON.parse(JSON.stringify(emptyContentPiece)),
    contentSetToPreview: [],
    contentPieceToPreview: {},
    pageNumber: 0,
    pageSize: 25,
    hasMore: true,
    filterBy: '',
    searchTerm: '',
    sortBy: 'modified',
    sortDirection: true,
    fileToUpload: null,
    isFetching: false,
    isFetchingAssignments: false,
    isSaving: false,
    error: {}
};

function contentReducer(state = initialState, action) {
    switch(action.type) {
        case FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE:
            return Object.assign({}, state, {
                isFetchingAssignments: true,
                error: {}
            });
        case FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE_SUCCESS:
            return Object.assign({}, state, {
                isFetchingAssignments: false
            });
        case FETCH_ASSIGNMENTS_FOR_CONTENT_PIECE_FAILURE:
            return Object.assign({}, state, {
                isFetchingAssignments: false,
                error: action.error
            });
        case FETCH_CONTENT:
            return Object.assign({}, state, {
                isFetching: true,
                error: {}
            });
        case FETCH_CONTENT_SUCCESS:
            let hasMore = true;
            if(action.data.length === 0) {
                hasMore = false;
            }
            return Object.assign({}, state, {
                all: state.all.concat(action.data),
                pageNumber: state.pageNumber + 1,
                hasMore: hasMore,
                isFetching: false
            });
        case FETCH_CONTENT_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                error: action.error,
                hasMore: false
            });
        case REMOVE_CONTENT:
            return Object.assign({}, state, {
                isSaving: true
            });
        case REMOVE_CONTENT_SUCCESS:
            return Object.assign({}, state, {
                isSaving: false,
                single: JSON.parse(JSON.stringify(emptyContentPiece))
            });
        case REMOVE_CONTENT_FAILURE:
            return Object.assign({}, state, {
                isSaving: false,
                error: action.error
            });
        case SAVE_CONTENT:
            return Object.assign({}, state, {
                isSaving: true,
                error: {}
            });
        case SAVE_CONTENT_SUCCESS:
            return Object.assign({}, state, {
                isSaving: false,
                single: action.data
            });
        case SAVE_CONTENT_FAILURE:
            return Object.assign({}, state, {
                isSaving: false,
                error: action.error
            });
        case EMPTY_CONTENT:
            return initialState;
        case CLEAR_CONTENT_TO_PREVIEW:
            return Object.assign({}, state, {
                contentPieceToPreview: {},
                contentSetToPreview: []
            });
        case CLEAR_CONTENT_SINGLE:
            return Object.assign({}, state, {
                single: JSON.parse(JSON.stringify(emptyContentPiece)),
                error: {}
            });
        case SET_CONTENT_SINGLE:
            return Object.assign({}, state, {
                single: action.data
            });
        case SET_CONTENT_PIECE_TO_PREVIEW:
            return Object.assign({}, state, {
                contentPieceToPreview: action.data
            });
        case SET_CONTENT_SET_TO_PREVIEW:
            return Object.assign({}, state, {
                contentSetToPreview: action.data
            });
        case UPDATE_CONTENT:
            return action.data;
        case UPDATE_SEARCH_TERM:
            return Object.assign({}, state, {
                searchTerm: action.data
            });
        case UPDATE_FILE_TO_UPLOAD:
            return Object.assign({}, state, {
                fileToUpload: action.data
            });
        default:
            return state;
    }
}

export default contentReducer;



// WEBPACK FOOTER //
// ./src/containers/ContentPage/store/reducers.js